import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import RoboticIcon from '../../components/customIcons/RoboticIcon';
import { useTranslate } from '../../lib/i18n';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const WelcomeSection = () => {
  const navigate = useNavigate();
  const t = useTranslate();

  return (
    <Card className="text-center animate-slide-up-3 opacity-0 bg-secondary text-secondary-foreground">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-secondary-light text-secondary-light-foreground">
        <RoboticIcon size={26} />
      </div>

      <h1>{t('common.welcomeSection.title')}</h1>

      <p className="text-sm">{t('common.welcomeSection.description')}</p>

      <Button
        className="relative w-full justify-center"
        onClick={() => {
          navigate({ pathname: '/ai-chatbot', search: location.search }, { replace: true });
        }}
      >
        <span>{t('common.welcomeSection.chatWithBot')}</span>
        <span className="absolute right-3 flex h-5 w-5 items-center">
          <ArrowRight size={20} />
        </span>
      </Button>

      <div className="text-center">
        <a
          href={t('common.dataPrivacyUrl')}
          target="_blank"
          className="text-sm underline"
          rel="noreferrer"
        >
          {t('common.welcomeSection.moreInfo')}
        </a>
      </div>
    </Card>
  );
};

export default WelcomeSection;
